import React from 'react';
import PropTypes from 'prop-types';
import './CtaPanel';
import './CtaPanelRow.scss';
import CtaPanel from "./CtaPanel";

const propTypes = {
    ctaPanels: PropTypes.array
};


export default class CtaPanelRow extends React.Component{
    constructor (props) {
        super(props);
    }

    render() {
        const{ctaPanels} = this.props;

        return(
            <section>
                <div className='panels-row-container'>
                    {this.props.ctaPanels.map((ctapanel, index) =>
                        <CtaPanel key={index} panel={ctapanel}/>
                    )}

                </div>

            </section>
        )
    }
};

CtaPanelRow.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/CtaPanelRow/index.js